<template>
    <div class="row">
        <div class="col-md-8">
            <div class="card">
                <div class="card-body">
                    <div class="bgloading" v-show="iniloading"><Loader></Loader></div>
                    <div class="row">
                        <div class="col-md-6" v-for="(i, index) in getList" :key="index">
                            <div
                                class="card"
                                style="
                                    margin-bottom: 40px;
                                    border: 1px solid #e0e0e0;
                                    background-color: #f9f9f9;
                                "
                            >
                                <div class="card-header special-head">
                                    <div class="row mobile_spc">
                                        <div class="col-xs-2 col-sm-2">
                                            <div class="onoffswitch">
                                                <input
                                                    type="checkbox"
                                                    :id="'cat' + i.id"
                                                    :checked="i.status"
                                                    class="onoffswitch-checkbox"
                                                    @click="changeStatus('status', i)"
                                                />
                                                <label
                                                    class="onoffswitch-label"
                                                    :for="'cat' + i.id"
                                                >
                                                    <span
                                                        class="onoffswitch-inner"
                                                    ></span>
                                                    <span
                                                        class="onoffswitch-switch"
                                                    ></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-xs-8 col-sm-8 col-md-6 col-lg-8">
                                            <span
                                                style="
                                                    padding-left: 8px;
                                                    font-size: 17px;
                                                    text-align: center;
                                                "
                                                >{{ i.day }}</span
                                            >
                                        </div>
                                        <div class="col-xs-2 col-sm-2">
                                            <button
                                                type="button"
                                                class="btn btn-dark btn-sm sp-m"
                                                @click="editItem(i)"
                                            >
                                                <i class="fas fa-pen"></i>
                                                {{ $t("lang.label_edit") }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body special-body">
                                    <h5 style="color: red">{{ i.day }}</h5>
                                    <h3>
                                        <b>{{ i.title }}</b>
                                    </h3>
                                    <h5
                                        style="color: #000; font-weight: bold"
                                        v-if="i.price && isNaN(i.price) !== true"
                                    >
                                        {{ currency }}{{ i.price | formatMoney }}
                                    </h5>
                                    <div class="description" v-html="i.description"></div>
                                    <div class="previewimg"
                                        :style="'background-image:url(' +require('@/assets/pic_special.png') +')'"
                                    >
                                        <div class="load" v-if="imgload && index === indexEdit">
                                            <loader></loader>
                                        </div>
                                        <div class="btns_action2">
                                            <button
                                                type="button"
                                                @click="DelImage(i.id)"
                                                v-if="i.is_files !== false"
                                            >
                                                <i class="fas fa-trash"></i>
                                            </button>
                                        </div>
                                        <div class="btns_action">
                                            <button
                                                type="button"
                                                @click="ShowImage(i)"
                                                v-if="i.is_files !== false"
                                            >
                                                <i class="fas fa-search-plus"></i>
                                            </button>
                                            <button
                                                type="button"
                                                @click="
                                                    displayRef(
                                                        'picture_img' + i.id,
                                                        index
                                                    )
                                                "
                                            >
                                                <i class="fas fa-pen"></i>
                                            </button>
                                        </div>
                                        <img
                                            v-if="i.is_files !== false"
                                            :src="url + 'thumbnail/' + i.image"
                                            alt=""
                                            width="100%"
                                            id="demo"
                                            v-bind:class="['image_special' + i.id, 'img-preview-special']"
                                        />
                                        <input
                                            type="file"
                                            style="display: none"
                                            :ref="`picture_img${i.id}`"
                                            accept="image/jpeg,image/jpg"
                                            @change="fileportada($event, i, index)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            :class="['col-md-4', getActionSpecials === true ? 'AsideStaticBg' : 'bgAside']"
        >
            <div class="col-md-4 AsideStatic aside-special" v-if="getActionSpecials">
                <component :is="asideRender"></component>
            </div>
        </div>
        <modal
            name="modal_image_preview"
            height="auto"
            width="700px"
            :resizable="true"
            :adaptive="true"
            :scrollable="true"
            class="imgPreview"
            :reset="true"
            :min-height="400"
        >
            <div class="card-header">
                {{ product_name_preview }}
                <button
                    @click="closeModal"
                    class="closeIcon"
                    style="background-color: #b7b7b7"
                >
                    <span></span>
                </button>
            </div>
            <div class="card-body">
                <img
                    :src="image_preview_modal"
                    style="
                        text-align: center;
                        display: block;
                        margin: 0 auto;
                        max-width: 100%;
                        min-height: 300px;
                    "
                    alt=""
                />
            </div>
        </modal>
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader.vue";
import formSpecials from "@/components/dimenu/specials/form_specials.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
    name: "tableSpecials",
    components: {
        Loader,
        formSpecials,
    },
    data () {
        return {
            showHidden: false,
            index: [],
            isloading: false,
            load: false,
            url: null,
            image_preview_modal: null,
            product_name_preview: null,
            imageCover: null,
            editAction: false,
            imageUpload: null,
            asideRender: "",
            imgload: false,
            indexEdit: null,
            dataImg: [],
            currency: localStorage.getItem("currency"),
            iniSpecialList: [],
            iniloading: false,
        }
    },
    created () {
        this.getSpecials();
    },
    methods: {
        displayRef(ref, index) {
            this.indexEdit = index;
            this.$refs[ref][0].click();
        },
        DelImage(image) {
            this.$swal({
                title: window.lang2.msj_del_cover,
                text: window.lang2.msj_you_sure,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: window.lang2.msj_del_it,
            }).then((result) => {
                if (result.value) {
                    window.master
                        .delete(
                            "/menu/specials/delimage/" +
                                window.localAccountID +
                                "/" +
                                window.localuserdata +
                                "/" +
                                image,
                            {
                                org_id: window.localuserdata,
                                user_id: window.localAccountID,
                                id: image,
                            }
                        )
                        .then((response) => {
                            this.getSpecials();
                        })
                        .catch((error) => console.log(error));
                }
            });
        },
        subirImage(index, i, imgFile) {
            this.imgload = true;
            let fileSendHeader = { headers: { "Content-Type": "multipart/form-data" } };
            let formData = new FormData();
            formData.append("image", imgFile);
            formData.append("id", i.id);
            formData.append("imageOld", i.image);
            formData.append("org_id", window.localuserdata);
            formData.append("user_id", window.localAccountID);
            window.master
                .post("/menu/special/upload", formData, fileSendHeader)
                .then((response) => {
                    this.imgload = false;
                    console.log("data response", response.data);
                    this.getSpecials();
                    if (response.data.image_large) {
                        self.data[index].error_image = true;
                        return;
                    }
                    self.data[index].error_image = false;
                    //this.imageActual = response.data.image
                    this.imageUpload = null;
                    this.getList[index].url = response.data.url;
                    this.getList[index].image = response.data.image;
                })
                .catch((error) => {
                    this.isLoading = false;
                });
        },

        fileportada(event, i, index) {
            let self = this;
            if (event.target.files && event.target.files[0]) {
                let reader = new FileReader();
                reader.readAsDataURL(event.target.files[0]);
                let img = new Image();
                reader.onload = function (e) {
                    img.src = e.target.result;
                    img.onload = function () {
                        // console.log(this.width);
                        // console.log(this.height);
                        if (this.width > 399 && this.height > 399) {
                            reader.onload = function (e) {
                                let d = (document.querySelector(
                                    ".image_special" + i.id
                                ).src = e.target.result);
                                self.imageCover = e.target.result;
                                self.imageUpload = event.target.files[0];
                            };
                            self.subirImage(index, i, event.target.files[0]);
                        } else {
                            event.target.value = "";
                            self.imgload = false;
                            self.imageCover = null;
                            self.imageUpload = null;
                            self.$swal({
                                title: "Error",
                                text: window.lang2.label_valcover,
                                type: "warning",
                                showCancelButton: true,
                            });
                        }
                    };
                };
            }
        },
        getSpecials() {
            this.load = true;
            this.isloading = true;
            this.imgload = true;
            window.master
                .get(
                    "menu/specials/" + window.localAccountID + "/" + window.localuserdata
                )
                .then((response) => {
                    this.imgload = false;
                    console.log("result special ", response.data);
                    this.isloading = false;
                    this.load = false;
                    let s = response.data.status;

                    this.url = response.data.url;
                    let d = response.data.result;
                    var t = Array();
                    for (let is in d) {
                        t.push(d[is].image);
                    }
                    this.dataImg = t;

                    for (let i in d) {
                        if (d[i].status === 1) {
                            d[i].status = true;
                        } else {
                            d[i].status = false;
                        }
                    }

                    let esp = Array(
                        "Domingo",
                        "Lunes",
                        "Martes",
                        "Miercoles",
                        "Jueves",
                        "Viernes",
                        "Sabado"
                    );
                    let ing = Array(
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    );
                    let res = Array();
                    let count = 0;

                    if (window.lang2.label_IE === 1 || window.lang2.label_IE === "1") {
                        for (let is in d) {
                            if (ing[count] === d[is].day) {
                                if (count > 0) {
                                    res.push({
                                        created_at: d[is].created_at,
                                        date: d[is].date,
                                        day: esp[count],
                                        description: d[is].description,
                                        id: d[is].id,
                                        image: d[is].image,
                                        org_id: d[is].org_id,
                                        price: d[is].price,
                                        status: d[is].status,
                                        title: d[is].title,
                                        updated_at: d[is].updated_at,
                                        user_id: d[is].user_id,
                                        is_files: d[is].is_files,
                                    });
                                }
                            }
                            count++;
                        }
                        res.push({
                            created_at: d[0].created_at,
                            date: d[0].date,
                            day: esp[0],
                            description: d[0].description,
                            id: d[0].id,
                            image: d[0].image,
                            org_id: d[0].org_id,
                            price: d[0].price,
                            status: d[0].status,
                            title: d[0].title,
                            updated_at: d[0].updated_at,
                            user_id: d[0].user_id,
                            is_files: d[0].is_files,
                        });
                    } else {
                        for (let is in d) {
                            if (ing[count] === d[is].day) {
                                if (count > 0) {
                                    res.push({
                                        created_at: d[is].created_at,
                                        date: d[is].date,
                                        day: ing[count],
                                        description: d[is].description,
                                        id: d[is].id,
                                        image: d[is].image,
                                        org_id: d[is].org_id,
                                        price: d[is].price,
                                        status: d[is].status,
                                        title: d[is].title,
                                        updated_at: d[is].updated_at,
                                        user_id: d[is].user_id,
                                        is_files: d[is].is_files,
                                    });
                                }
                            }
                            count++;
                        }
                        res.push({
                            created_at: d[0].created_at,
                            date: d[0].date,
                            day: ing[0],
                            description: d[0].description,
                            id: d[0].id,
                            image: d[0].image,
                            org_id: d[0].org_id,
                            price: d[0].price,
                            status: d[0].status,
                            title: d[0].title,
                            updated_at: d[0].updated_at,
                            user_id: d[0].user_id,
                            is_files: d[0].is_files,
                        });
                    }
                    this.$store.commit("SET_SPECIALS_LISTS", res);
                    this.iniSpecialList = res;
                })
                .catch((error) => {
                    this.isloading = false;
                });
        },
        changeStatus(action, i) {
            let active = 0;
            if (i.status) {
                active = 0;
            } else {
                active = 1;
            }

            window.master
                .put("menu/specials/status/" + i.id, {
                    org_id: window.localuserdata,
                    status: active,
                })
                .then((response) => {
                    i.status = !i.status;
                })
                .catch((error) => console.log(error));
        },
        editItem(i) {
            console.log("edit mobile");
            this.editAction = true;
            let display = { display: true };

            this.$store.commit("SET_ACTIONS_SPECIALS", true);
            this.$store.commit("SET_CURRENT_SPECIALS", { ...display, ...i });
            this.asideRender = "formSpecials";
            //this.showHidden = true;
        },
        ShowImage(i) {
            this.$modal.show("modal_image_preview");
            this.image_preview_modal = this.url + "large/" + i.image;
            this.product_name_preview = i.title;
        },
        closeModal() {
            this.$modal.hide("modal_image_preview");
        },
    },
    computed: {
			/*   checkDate() {
		let dateObj = new Date();
		let month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
		let date = ("0" + dateObj.getDate()).slice(-2);
		let year = dateObj.getFullYear();
		let shortDate = year + "-" + month + "-" + date;
		let check = this.data.some((e) => e.date === shortDate);
		return check;
		}, */
        getList() {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.iniloading = true;
            if (this.$store.getters.getSpecialsAll.length > 0) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.iniSpecialList = this.$store.getters.getSpecialsAll;
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.iniloading = false;
            }
            return this.iniSpecialList;
        },
		/* specialItemCurrent(){
		return this.$store.getters.specialItemCurrent;
		}, */
        ...mapGetters(["specialItemCurrent", "getActionSpecials"]),
    },
    watch: {
        getActionSpecials: function (newVal, oldVal) {
            if (newVal === true) {
                this.isloading = false;
            } else {
                // this.isloading = true
            }
        },
        getList: function (newVal, oldVal) {
            this.isloading = false;
        },
    },
}
</script>
<style lang="scss" scoped>
.bgAside {
    background-color: #fff;
    position: fixed;
    right: 0;
    height: 87vh;
}
.AsideStatic {
    background-color: #fff;
    position: fixed;
    right: 0;
    height: 87vh;
    max-width: 30.33333%;
}
@media (min-width: 1366px) {
    .AsideStatic {
        padding-right: 0;
        padding-left: 0;
    }
    .bgAside {
        max-width: 30.33333%;
    }
    .AsideStaticBg {
        max-width: 30.33333%;
        /* padding-right: 0px;
      padding-left: 0px; */
    }
}
.v--modal-overlay.v--modal-box {
    position: absolute !important;
    top: 10% !important;
    left: 0.1px !important;
    margin: 0 auto;
    right: 0;
    transform: translateY(-50%) !important;
}
.aside-special {
    position: fixed;
    right: 0;
    height: 87vh;
    overflow: auto;
}
@media (min-width: 1366px) {
    .aside-special {
        .card {
            margin-left: 20px;
        }
    }
}
@media (max-width: 767px) {
    .mobile_spc {
        display: flex;
        flex-wrap: nowrap;
    }
    .sp-m {
        float: right;
    }
    .aside-special {
        position: fixed;
        top: 49px;
        right: 0;
        z-index: 10;
        overflow: auto;
        height: 90vh;
        width: 100%;
    }
}
@media (min-width: 768px) and (max-width: 1555px) {
    .sp-m {
        font-size: 0;
        i {
            font-size: 11px;
        }
    }
}
@media (max-width: 767px) {
    .AsideStatic {
        width: 100% !important;
        max-width: 100%;
    }
    .bgAside {
        display: none;
    }
    .mobile_spc {
        display: flex;
        flex-wrap: nowrap;
    }
    .sp-m {
        float: right;
    }
    .aside-special {
        position: fixed;
        top: 49px;
        right: 0;
        z-index: 10;
        overflow: auto;
        height: 90vh;
        width: 100%;
    }
}

@media (min-width: 768px) and (max-width: 1365px) {
    .mobile_spc {
        display: flex;
        flex-wrap: nowrap;
    }
    .sp-m {
        font-size: 0;
        i {
            font-size: 11px;
        }
    }
}
.btns_action {
    display: flex;
    position: absolute;
    top: 5px;
    right: 5px;
    button {
        border: 0;
        background-color: #fff;
        cursor: pointer;
        margin-left: 5px;
        border-radius: 4px;
    }
}

.btns_action2 {
    float: left;
    position: absolute;
    top: 5px;
    left: 5px;
    button {
        border: 0;
        background-color: #fff;
        cursor: pointer;
        margin-left: 5px;
        border-radius: 4px;
    }
}

.special-body {
    text-align: center;
}
.card-header {
    background-color: #222223;
    color: #fff;
    text-align: center;
}
.load {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #ffffff8c;
    z-index: 10;
}
.imgPreview {
    //min-height:400px;
}
.onoffswitch {
    position: relative;
    // width: 60px;
    width: 95px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}
.onoffswitch-checkbox {
    display: none;
}
.onoffswitch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    text-align: left;
    //border: 1px solid #fff;
    border-radius: 20px;
}
.onoffswitch-inner {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.1s ease-in 0s;
}
.onoffswitch-inner:before,
.onoffswitch-inner:after {
    display: block;
    float: left;
    width: 50%;
    height: 21px;
    padding: 0;
    line-height: 20px;
    font-size: 12px;
    color: white;
    font-family: Trebuchet, Arial, sans-serif;
    font-weight: bold;
    box-sizing: border-box;
}
.onoffswitch-inner:before {
    content: "On";
    padding-left: 10px;
    background-color: #5ac146;
    color: #ffffff;
}
.onoffswitch-inner:after {
    content: "Off";
    padding-right: 10px;
    background-color: #d65353;
    color: #fff;
    text-align: right;
}
.onoffswitch-switch {
    display: block;
    width: 15px;
    height: 15px;
    margin: 6px;
    background: #fff;
    position: absolute;
    top: -3px;
    bottom: 0;
    // right: 33px;
    right: inherit;
    //border: 1px solid #5ac146;
    border-radius: 20px;
    transition: all 0.1s ease-in 0s;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
    right: 0px;
}
.bgloading {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
}
.noneImg {
    display: none;
}
.previewimg{
    border: 1px solid #e0e0e0;
    background-color: #f1f1f1;
    text-align: center;
    height: 300px;
    overflow: hidden;
    position: relative;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
}
.img-preview-special{
    height: 100%;
    width: auto;
}
</style>
